'use strict';

import 'Plugins/sticky-fill.js';

export default function() {
	if (document.documentElement.classList.contains('ie')) {
		var stickyElements = document.querySelectorAll('.sticky');

		if (typeof stickyElements === 'undefined') {
			return;
		}

		Stickyfill.add(stickyElements);
	}
};
